import { KeyFeaturesPipe } from './key-features.pipe';
import { EarliestDeliveryDateTextPipe } from './earliest-delivery-date-text.pipe';
import { FirstUpperBoldPipe } from './first-upper-bold.pipe';
import { FilterDataByOfferTypePipe } from './filter-data-by-offer-type.pipe';
import { IsCheckedPipe } from './is-checked.pipe';
import { FormatRrpPipe } from './format-rrp.pipe';
import { DateFormatPipe, TimeFormatPipe } from './formatting.pipe';

export { DateFormatPipe, TimeFormatPipe };

export const pipes = [
  FilterDataByOfferTypePipe,
  IsCheckedPipe,
  FirstUpperBoldPipe,
  FormatRrpPipe,
  EarliestDeliveryDateTextPipe,
  KeyFeaturesPipe,
  TimeFormatPipe,
  DateFormatPipe,
];
